export default {
  EVENT_REPORT_DETAIL_LIST_REQUEST: 'APP/EVENT_REPORT_DETAIL/EVENT_REPORT_DETAIL_LIST_REQUEST',
  EVENT_REPORT_DETAIL_LIST_SUCCESS: 'APP/EVENT_REPORT_DETAIL/EVENT_REPORT_DETAIL_LIST_SUCCESS',
  EVENT_REPORT_DETAIL_LIST_ERROR: 'APP/ EVENT_REPORT_DETAIL/EVENT_REPORT_DETAIL_LIST_ERROR',
};
